import { render } from "./index.vue?vue&type=template&id=07765ef8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=07765ef8&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07765ef8"]])

export default __exports__